import { coreApi } from 'src/api/config';
import fetchCustomConsentConfiguration from 'src/api/core/CustomConsentConfigurations/fetchCustomConsentConfiguration';
import fetchCustomConsentAgreements from 'src/api/core/CustomConsentAgreements/fetchCustomConsentAgreements';
import generateCustomConsentBatchBody from './generateCustomConsentBatchBody';
import { NH_CONSENT_CONFIGURATION_TYPE, NH_DATA_SHARE_CONSENT_CODE, NH_REFERRAL_CONSENT_CODE } from './constants';

const createCustomConsentBatchCommunication =
  async ({
    contactId, communicationId, referralIds, language,
  }) => {
    const [specificAgreementConfiguration, stateShareAgreementConfiguration] = await Promise.all([
      fetchCustomConsentConfiguration({
        consentCode: NH_REFERRAL_CONSENT_CODE,
        consentType: NH_CONSENT_CONFIGURATION_TYPE,
      }),
      fetchCustomConsentConfiguration({
        consentCode: NH_DATA_SHARE_CONSENT_CODE,
        consentType: NH_CONSENT_CONFIGURATION_TYPE,
      }),
    ]);

    const [specificAgreement, stateShareAgreement] = await Promise.all([
      fetchCustomConsentAgreements({
        configurationId: specificAgreementConfiguration.id, language,
      }),
      fetchCustomConsentAgreements({
        configurationId: stateShareAgreementConfiguration.id, language,
      }),
    ]);

    const body = generateCustomConsentBatchBody({
      communicationId,
      selectedReferralIds: referralIds,
      unselectedReferralIds: [],
      consentMethod: 'written',
      submissionMethod: 'digital_signature',
      specificAgreement: {
        id: specificAgreement.id, status: 'pending',
      },
      stateShareAgreement: {
        id: stateShareAgreement.id, status: 'pending',
      },
    });

    const response = await coreApi.batchCreateCustomConsents(contactId, body);
    return response;
  };

export default createCustomConsentBatchCommunication;
